module.exports = __webpack_public_path__ + "static/media/mudroad.d146c155.jpg";